import * as React from 'react';
import { Share16 } from '@cian/ui-kit/icons';
import { LinkButton } from '@cian/ui-kit';

interface IProps {
  urls: string[];
  onClick(): void;
}

export const ShareWhatsAppButton: React.FC<IProps> = ({ urls, onClick }) => {
  return (
    <LinkButton
      href={`https://wa.me/?text=${urls.join(', ')}`}
      target="_blank"
      rel="nofollow noreferrer"
      beforeIcon={<Share16 color="primary_100" />}
      size="XS"
      theme="fill_white_primary"
      onClick={onClick}
    >
      Поделиться в WhatsApp
    </LinkButton>
  );
};
